var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column align-items-center px-2"},[_c('b-badge',{attrs:{"pill":"","variant":"dark"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"box"},[_vm._v(_vm._s(_vm.formatedValue))]),_c('div',{staticClass:"text-green",class:_vm.increaseClass},[_vm._v(_vm._s(_vm.formatedFooter))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }